import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  addbenefit,
  deletebenefit,
  getAllbenefit,
  getEligliblityOptions,
  statusChnageBenefit,
  updatebenefit,
} from "../../Api/services/benefitService";

const benefitSlice = createSlice({
  name: "benefit",
  initialState: {
    benefitData: [],
    benefitOptionsData: [],
    error: null,
    loading: false,
  },
  extraReducers: (builder) => {
    //add benefit
    builder
      .addCase(addbenefit.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(addbenefit.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(addbenefit.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //get benefit list
    builder
      .addCase(getAllbenefit.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAllbenefit.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        }
        return {
          ...state,
          benefitData: action.payload,
          loading: false,
        };
      })
      .addCase(getAllbenefit.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //update benefit
    builder
      .addCase(updatebenefit.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updatebenefit.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(updatebenefit.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //update status
    builder
      .addCase(statusChnageBenefit.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(statusChnageBenefit.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(statusChnageBenefit.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //delete benefirt

    builder
      .addCase(deletebenefit.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(deletebenefit.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(deletebenefit.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //benefit options data
    builder
      .addCase(getEligliblityOptions.pending, (state) => {
        return {
          ...state,
        };
      })
      .addCase(getEligliblityOptions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          benefitOptionsData: action.payload,
        };
      })
      .addCase(getEligliblityOptions.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          error: action.payload,
        };
      });
  },
});

export default benefitSlice.reducer;
